export var UserEntity;
(function (UserEntity) {
    let EntityType;
    (function (EntityType) {
        EntityType["ACCOUNT"] = "ACCOUNT";
        EntityType["GROUP"] = "GROUP";
    })(EntityType = UserEntity.EntityType || (UserEntity.EntityType = {}));
    let USER_ROLE_MAP;
    (function (USER_ROLE_MAP) {
        USER_ROLE_MAP["READ"] = "READ";
        USER_ROLE_MAP["EDIT"] = "EDIT";
        USER_ROLE_MAP["MANAGE"] = "MANAGE";
        USER_ROLE_MAP["CUSTOM"] = "CUSTOM";
    })(USER_ROLE_MAP = UserEntity.USER_ROLE_MAP || (UserEntity.USER_ROLE_MAP = {}));
})(UserEntity || (UserEntity = {}));
